import React, { useState, useEffect, useCallback, useRef } from "react";
import backarrow from "../../assets/svg/backarrow.svg";
import { useLocation, useNavigate } from "react-router-dom";
import "./checking.css";
import { Card, Button, ProgressBar, Form, Container, Row, Col, Toast, ToastContainer } from "react-bootstrap";
import upload from "../../assets/svg/upload-img.svg";
import checked from "../../assets/svg/checked.svg";
import locationImg from "../../assets/svg/location.svg";
import department from "../../assets/svg/department-ch.svg";
import usedBy from "../../assets/svg/used-by.svg";
import mail from "../../assets/svg/mail.svg";
import attachment from "../../assets/svg/attachment.svg";
import add from "../../assets/svg/add.svg";
import { saveDataEntryApi, submitAssetCheckingApi } from "../asset-list/asset-api";
import close from "../../assets/svg/close-chip.svg";
import { getProfileViewApi } from "../assets/asset-api";

export default function CheckingView() {
  const location = useLocation();
  const navigate = useNavigate();
  const { assetDetail, type } = location.state || {};
  const [checkingType, setCheckingType] = useState("Check-Out");

  const [currentReading, setCurrentReading] = useState("");
  const [referenceList, setReferenceList] = useState([]);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  useEffect(() => {
    if (assetDetail != null && assetDetail.last_status !== "error") {
      if (assetDetail.last_status === "Check-Out") {
        setCheckingType("Check-In");
      }
      if (assetDetail.last_status === "Check-In") {
        setCheckingType("Check-Out");
      }
      if (assetDetail.last_status === "General") {
        setCheckingType("General");
      }
    }
    if (type !== "Checking") {
      setCheckingType("General");
    }
    if (assetDetail != null) {
      getProfileView(assetDetail.id);
    }
  }, [assetDetail]);
  const [profileView, setProfileView] = useState("");
  const getProfileView = async (id) => {
    try {
      const response = await getProfileViewApi(id);
      if (response.data.success === true) {
        setProfileView(response.data.profile);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const checkingUpdate = async (status) => {
    // If reporting an issue, require at least one reference
    if (!status && (!referenceList || referenceList.length === 0 || referenceList.every((r) => !r.ref_no || !r.ref_no.trim()))) {
      setSnackbarMessage("Please add at least one reference before reporting an issue");
      setSnackbarStatus(false);
      handleSnackbarShow();
      return;
    }

    const validReferences = (referenceList || []).filter((r) => (r.ref_no && r.ref_no.trim() !== "") || r.attachment);

    const payload = {
      id: assetDetail.id,
      type: type, //Validation, Checking
      process_type: checkingType, //General, Check-In, Check-Out
      status: status,
      references: validReferences,
    };
    try {
      const response = await submitAssetCheckingApi(payload);
      if (response.status === 200 && response.data.success === true) {
        const msg = response.data.message || (status ? "Checked successfully" : "Issue reported successfully");
        sessionStorage.setItem("toastMessage", msg);
        sessionStorage.setItem("toastStatus", "true");
        navigate(-1, { state: { toastMessage: msg, toastStatus: true } });
      } else if (response.status === 400 || response.data?.success === false) {
        setSnackbarMessage(response.data?.message || "Please complete required details");
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } catch (err) {
      setSnackbarMessage(err.response?.data?.message || "An error occurred");
      setSnackbarStatus(false);
      handleSnackbarShow();
    }
  };

  const fileInputs = useRef([]);
  const handleFileClick = (index) => {
    if (fileInputs.current[index]) {
      fileInputs.current[index].click();
    }
  };
  const handleFileChange = (event, index) => {
    const file = event.target.files[0];
    if (file /* && file.type.startsWith("image/") */) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result;
        const tempRefList = [...referenceList];
        tempRefList[index].attachment = base64String;
        setReferenceList(tempRefList);
      };
      reader.readAsDataURL(file);
    } else {
      alert("Please select a valid image file.");
    }
  };
  const [validations, setValidations] = useState({
    reading: "",
  });

  const saveDataEntry = async () => {
    try {
      const response = await saveDataEntryApi(assetDetail.id, { reading: currentReading, asset_id: assetDetail.id });
      if (response.status === 200 && response.data.success === true) {
        const msg = response.data.message || "Data entry saved successfully";
        sessionStorage.setItem("toastMessage", msg);
        sessionStorage.setItem("toastStatus", "true");
        navigate(-1, { state: { toastMessage: msg, toastStatus: true } });
      } else if (response.status === 400) {
        const errors = response.data?.error || {};
        const validationTemp = {
          reading: errors.current_reading ? errors.current_reading[0] : (errors.reading ? errors.reading[0] : ""),
        };
        setValidations(validationTemp);
        setSnackbarMessage(response.data?.message || errors.current_reading?.[0] || "Validation error");
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } catch (err) {
      setSnackbarMessage(err.response?.data?.message || "An error occurred while saving reading");
      setSnackbarStatus(false);
      handleSnackbarShow();
    }
  };

  if (assetDetail == null) {
    return (
      <div className="container-fluid px-2" style={{ overflowY: "auto", width: "100%", height: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div>
          <p>No asset data to show. Please go back and scan again.</p>
          <img src={backarrow} alt="back" onClick={() => navigate(-1)} className="cursor-pointer" />
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid px-2" style={{ overflowY: "auto", width: "100%", height: "100vh" }}>
      <div className="style-justify-between px-3" style={{ height: "56px" }}>
        <div className="style-justify-start">
          <img src={backarrow} alt="back" onClick={() => navigate(-1)} className="cursor-pointer" /* style={{ width: "14px", height: "14px" }} */ />
          <div className="ps-3 font-20-500-172B4D">{assetDetail.name ?? ""}</div>
        </div>
        <div className="style-justify-start">
          {type !== "Daily entry" && (
            <div className="style-justify-end">
              <select value={checkingType} onChange={(e) => setCheckingType(e.target.value)} style={{ width: "118px", height: "40px", borderRadius: "100px", backgroundColor: "#FFFFFF", border: "1px solid #EBEBEB", fontSize: "14px", fontWeight: "500", color: "#172B4D" }} className="me-1 ps-2 custom-select cursor-pointer">
                <option value="General">General</option>
                <option value="Check-Out">Check Out</option>
                <option value="Check-In">Check In</option>
              </select>

              <div
                onClick={() => {
                  checkingUpdate(false);
                }}
                className="report-btn style-justify-center cursor-pointer"
              >
                Report
              </div>

              <div
                onClick={() => {
                  checkingUpdate(true);
                }}
                className="ms-2 checked-btn style-justify-center cursor-pointer"
              >
                Checked
              </div>
            </div>
          )}
        </div>
      </div>
      <Row /* style={{width:'100%',}} */>
        <Col sm={12} md={6} className="mt-2">
          <div className="container-box">
            <div className="style-justify-between">
              <div className="style-justify-start">
                <div style={{ width: "80px", height: "80px", borderRadius: "100px", border: "1px solid #E5E5E5" }}>
                  <img src={profileView != null && profileView !== "" ? profileView : upload} alt="Upload" style={{ width: "80px", height: "80px", borderRadius: "100px", border: "1px solid #E5E5E5" }} />
                </div>
                <div className="ms-3">
                  <div className="font-20-500-172B4D">{assetDetail.name ?? ""}</div>
                  <div className="mt-2 style-justify-start">
                    <div className="font-14-300-3B84E6">{assetDetail.asset_type ?? ""}</div>
                    <div className="mx-3" style={{ width: "4px", height: "4px", borderRadius: "100px", background: "#D9D9D9" }}></div>
                    <div className="ms-1 style-justify-center px-2 py-1" style={{ background: "#E9F1FF", borderRadius: "12px", fontSize: "12px", fontWeight: "400", color: "#172B4D" }}>
                      EOL : <span className="ms-1 font-12-600-172B4D">{assetDetail.eol ?? ""}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="px-2 py-2 style-justify-center" style={{ height: "36px", borderRadius: "100px", background: "#E0FFE8" }}>
                  <img src={checked} alt="Checked" />
                  <span className="ms-2 font-14-400-172B4D">{assetDetail.asset_status ?? ""}</span>
                </div>
              </div>
            </div>
            <div className="mt-2 style-justify-start">
              <div className="style-justify-start">
                <div className="font-14-300-8790A1">Asset Tag :</div> <div className="ms-2 font-14-400-172B4D">{assetDetail.asset_tag ?? ""}</div>
              </div>
              <div className="mx-3" style={{ height: "15px", width: "1px", background: "#C7C7C7" }}></div>
              <div className="style-justify-start">
                <div className="font-14-300-8790A1">Workspace :</div> <div className="ms-2 font-14-400-172B4D">{assetDetail.usage_type ?? ""}</div>
              </div>
            </div>
            <div className="mt-3 mb-3" style={{ height: "1px", width: "100%", background: "#EBEBEB" }}></div>
            <div className="font-18-500-172B4D">Assignment Information</div>
            <div className="mt-3 style-justify-start">
              <div style={{ width: "160px" }} className="font-14-300-8790A1">
                Location
              </div>
              <div className="style-justify-start">
                {" "}
                <img src={locationImg} alt="location" />
                <span className="ms-2 font-15-300-21272C">{assetDetail.location ?? ""}</span>
              </div>
            </div>

            <div className="mt-3 style-justify-start">
              <div style={{ width: "160px" }} className="font-14-300-8790A1">
                Department
              </div>
              <div className="style-justify-start">
                {" "}
                <img src={department} alt="Department" />
                <span className="ms-2 font-15-300-21272C">{assetDetail.department ?? ""}</span>
              </div>
            </div>

            <div className="mt-3 style-justify-start">
              <div style={{ width: "160px" }} className="font-14-300-8790A1">
                Used by
              </div>
              <div className="style-justify-start">
                {" "}
                <img src={usedBy} alt="usedBy" />
                <span className="ms-2 font-15-300-21272C">{assetDetail.assignee_name ?? "---"}</span>
              </div>
            </div>

            <div className="mt-3 style-justify-start">
              <div style={{ width: "160px" }} className="font-14-300-8790A1">
                Managed by
              </div>
              <div className="style-justify-start">
                {" "}
                <img src={usedBy} alt="Managedby" />
                <span className="ms-2 font-15-300-21272C">{assetDetail.managed_by ?? "---"}</span>
              </div>
            </div>
            <div className="mt-3 mb-3" style={{ height: "1px", width: "100%", background: "#EBEBEB" }}></div>
            <div className=" font-18-500-172B4D">Description</div>
            <div className="mt-3 font-15-300-21272C">{assetDetail.description ?? "---"} </div>
          </div>
        </Col>
        <Col sm={12} md={6} className="mt-2">
          <div className="container-box">
            <div className=" font-18-500-172B4D">Assigned to</div>
            <div className="mt-2 style-justify-start">
              <img src={usedBy} alt="Upload" style={{ width: "48px", height: "48px", borderRadius: "100px" }} />
              <div className="ms-2">
                <div className="font-16-600-172B4D">{assetDetail.assignee_name ?? "---"}</div>
                <div className="style-justify-start">
                  <img src={mail} alt="Upload" /> <span className="ms-2 font-14-300-3B84E6">{assetDetail.assignee_email ?? "---"}</span>{" "}
                </div>
              </div>
            </div>
            <div className="mt-2 font-14-300-8790A1">
              {" "}
              Assigned on <span className="ms-1 font-14-400-172B4D">{assetDetail.assigned_on ?? "---"}</span>{" "}
            </div>
            <div className="mt-3 mb-3" style={{ height: "1px", width: "100%", background: "#EBEBEB" }}></div>
            {(type === "Validation" || type === "Checking") && (
              <div>
                <div className=" font-18-500-172B4D">Reference</div>
                <div>
                  {referenceList?.map((reference, i) => (
                    <Row className="mt-2">
                      <Col sm={12} md={5}>
                        <div className="field-title mb-1">Reference No</div>
                        <input
                          type="text"
                          placeholder="Enter here"
                          className="input-field w-100"
                          value={reference.ref_no}
                          onChange={(e) => {
                            const tempRef = [...referenceList];
                            tempRef[i].ref_no = e.target.value;
                            setReferenceList(tempRef);
                          }}
                        />
                      </Col>
                      <Col sm={12} md={3}>
                        <div className="field-title mb-1">Quantity</div>
                        <input
                          type="text"
                          placeholder="Enter here"
                          className="input-field w-100"
                          value={reference.qty}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, "");
                            const tempRef = [...referenceList];
                            tempRef[i].qty = value;
                            setReferenceList(tempRef);
                          }}
                        />
                      </Col>
                      <Col sm={12} md={4}>
                        <div className="field-title mb-1">Attachment</div>
                        {(reference.attachment == null || reference.attachment === "") && (
                          <div onClick={() => handleFileClick(i)} className="style-justify-center px-2 py-2 add-attachment">
                            <img src={attachment} alt="Attachment" />
                            <div className="font-13-500-3B84E6">Add attachment</div>
                          </div>
                        )}
                        {reference.attachment != null && reference.attachment !== "" && (
                          <div key={"base-image-" + i} className="mt-2 style-justify-between" style={{ width: "241px", height: "52px", borderRadius: "12px", padding: "8px 12px", background: "#F8F8F8" }}>
                            <div className="style-justify-start">
                              <img src={reference.attachment != null && reference.attachment !== "" ? reference.attachment : ""} alt="complaint" style={{ width: "42px", height: "42px", borderRadius: "14px" }} />
                            </div>
                            <div>
                              <div style={{ display: "flex", justifyContent: "start", alignItems: "center" }}>
                                <img
                                  src={close}
                                  alt=""
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    const tempRefList = [...referenceList];
                                    tempRefList[i].attachment = "";
                                    setReferenceList(tempRefList);
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        )}
                        <input
                          ref={(el) => (fileInputs.current[i] = el)}
                          type="file"
                          accept=".jpg, .jpeg, .png, .pdf"
                          onChange={(e) => handleFileChange(e, i)}
                          style={{ display: "none" }} // Hide the actual file input
                        />
                      </Col>
                    </Row>
                  ))}
                  <div
                    className="mt-2 style-justify-center add-reference-btn"
                    onClick={() => {
                      const tempRef = [...referenceList];
                      tempRef.push({
                        ref_no: "",
                        qty: "",
                        attachment: "",
                      });
                      setReferenceList(tempRef);
                    }}
                  >
                    <img src={add} alt="Add" /> <span className="ms-2">Add</span>
                  </div>
                </div>
              </div>
            )}
          </div>

          {type === "Daily entry" && (
            <div className="container-box mt-2">
              <div className=" font-18-500-172B4D">Current reading</div>
              <div className="style-justify-start"></div>
              <div className="mt-2 style-justify-start">
                {" "}
                <input
                  style={{ flex: 1 }}
                  type="text"
                  placeholder="Enter here"
                  className="input-field w-100"
                  value={currentReading}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9.]/g, "").replace(/(\..*?)\..*/g, "$1");
                    setCurrentReading(value);
                  }}
                />
                <div onClick={() => saveDataEntry()} className="ms-2 submit-btn style-justify-center cursor-pointer">
                  Submit
                </div>
              </div>
              <span className="field-error">{validations.reading}</span>
            </div>
          )}
        </Col>
      </Row>

      <ToastContainer position="top-end" className="p-3" style={{ zIndex: 9999 }}>
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          <Toast.Body className="text-white">{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
}
